import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5" }
const _hoisted_2 = { class: "whitespace-normal p-7 pb-3 text-center text-black" }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = { class: "m-3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Nie ")
const _hoisted_6 = { class: "m-3" }
const _hoisted_7 = ["onClick"]

import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { UiButton } from '@/components/common/ui'

interface IPropsUiPopconfirm {
    fullWidth?: boolean
    text?: string
    disabled?: boolean
}
interface IEventUiPopconfirm {
    (e: 'confirm'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    fullWidth: { type: Boolean, required: false, default: false },
    text: { type: String, required: false, default: '' },
    disabled: { type: Boolean, required: false, default: false }
  },
  emits: ["confirm"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'confirm'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { fullWidth: boolean, text: string, disabled: boolean }



const onConfirmButtonClick = (close: () => void) => {
    emit('confirm')
    close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), {
    class: _normalizeClass(["relative", { 'w-full': props.fullWidth }])
  }, {
    default: _withCtx(({ open }) => [
      _createVNode(_unref(PopoverButton), { class: "w-full" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "translate-y-1 opacity-0",
        "enter-to-class": "translate-y-0 opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "translate-y-0 opacity-100",
        "leave-to-class": "translate-y-1 opacity-0"
      }, {
        default: _withCtx(() => [
          (open && !props.disabled)
            ? (_openBlock(), _createBlock(_unref(PopoverPanel), {
                key: 0,
                static: "",
                class: "bg-gray-stroke absolute z-10 px-4 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0"
              }, {
                default: _withCtx(({ close }) => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(props.text), 1),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(PopoverButton), {
                          as: _unref(UiButton),
                          href: "/insights"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }, 8, ["as"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("button", {
                          class: "button button--primary",
                          onClick: ($event: any) => (onConfirmButtonClick(close))
                        }, " Tak ", 8, _hoisted_7)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})